export default __webpack_public_path__ + "static/media/login.90eb2376.svg";